<template>
    <section>
        <o-skeleton circle width="64px" height="64px" />
    </section>
</template>
